const IBAN_LENGTHS: Record<string, number> = {
  AL: 28,
  AD: 24,
  AT: 20,
  AZ: 28,
  BH: 22,
  BE: 16,
  BA: 20,
  BR: 29,
  BG: 22,
  CR: 22,
  HR: 21,
  CY: 28,
  CZ: 24,
  DK: 18,
  DO: 28,
  EE: 20,
  EG: 29,
  FI: 18,
  FR: 27,
  GE: 22,
  DE: 22,
  GI: 23,
  GR: 27,
  GT: 28,
  HU: 28,
  IS: 26,
  IE: 22,
  IL: 23,
  IT: 27,
  JO: 30,
  KZ: 20,
  XK: 20,
  KW: 30,
  LV: 21,
  LB: 28,
  LI: 21,
  LT: 20,
  LU: 20,
  MK: 19,
  MT: 31,
  MR: 27,
  MU: 30,
  MD: 24,
  MC: 27,
  ME: 22,
  NL: 18,
  NO: 15,
  PK: 24,
  PS: 29,
  PL: 28,
  PT: 25,
  QA: 29,
  RO: 24,
  SM: 27,
  LC: 32,
  ST: 25,
  SA: 24,
  RS: 22,
  SK: 24,
  SI: 19,
  ES: 24,
  SE: 24,
  CH: 21,
  TL: 23,
  TN: 24,
  TR: 26,
  AE: 23,
  GB: 22,
  VA: 22,
  VG: 24,
  UA: 29,
  SC: 31,
  IQ: 23,
  BY: 28,
  SV: 28,
  LY: 25,
  SD: 18,
  BI: 27,
  DJ: 27,
  RU: 33,
  SO: 23,
  NI: 28,
  MN: 20,
  FK: 18,
  OM: 23,
  YE: 30,
  HN: 28,
  AO: 25,
  BF: 28,
  BJ: 28,
  CF: 27,
  CG: 27,
  CI: 28,
  CM: 27,
  CV: 25,
  DZ: 24,
  GA: 27,
  GQ: 27,
  GW: 25,
  IR: 26,
  MA: 28,
  MG: 27,
  ML: 28,
  MZ: 25,
  NE: 28,
  SN: 28,
  TD: 27,
  TG: 28,
  KM: 27,
};

export const validateIban = (value?: string) => {
  if (!value) {
    return undefined;
  }

  if(value.toLowerCase() === "no") return undefined

  const cleaned = value.replace(/\s+/g, "").toUpperCase();

  if (!/^[A-Z]{2}[0-9]{2}[A-Z0-9]+$/.test(cleaned)) {
    return "IBAN non valido";
  }

  const countryCode = cleaned.slice(0, 2);
  const expectedLength = IBAN_LENGTHS[countryCode];

  if (!expectedLength || cleaned.length !== expectedLength) {
    return "IBAN non valido";
  }

  const rearranged = cleaned.slice(4) + cleaned.slice(0, 4);
  const numericIban = rearranged.replace(/[A-Z]/g, (char) =>
    String(char.charCodeAt(0) - 55)
  );

  let remainder = "";
  for (let i = 0; i < numericIban.length; i += 7) {
    remainder = String(
      parseInt(remainder + numericIban.slice(i, i + 7), 10) % 97
    );
  }

  if (Number(remainder) !== 1) {
    return "IBAN non valido";
  }

  return undefined;
};
